import client from '../../client';

export const ADD_CHAPTER = 'ADD_CHAPTER';
export const DELETE_CHAPTER = 'DELETE_CHAPTER';
export const EDIT_CHAPTER = 'EDIT_CHAPTER';
export const FETCH_CHAPTERS = 'FETCH_CHAPTERS';
export const REORDER_CHAPTERS = 'REORDER_CHAPTERS';

export function addChapter(courseId, values) {
  return {
    type: ADD_CHAPTER,
    promise: client.post(`courses/${courseId}/chapters`, values),
  };
}

export function deleteChapter(courseId, chapterId) {
  return {
    chapterId,
    type: DELETE_CHAPTER,
    promise: client.delete(`courses/${courseId}/chapters/${chapterId}`),
  };
}

export function editChapter(courseId, id, values) {
  return {
    type: EDIT_CHAPTER,
    promise: client.put(`courses/${courseId}/chapters/${id}`, values),
  };
}

export function fetchChapters(courseId) {
  return {
    type: FETCH_CHAPTERS,
    promise: client.get(`courses/${courseId}/chapters/all`),
  };
}

export function reorderChapters(values) {
  return {
    type: REORDER_CHAPTERS,
    promise: client.patch('chapters/sort-order', values),
  };
}



// WEBPACK FOOTER //
// ./src/courses/chapters/actions.js